import History from '../../views/reservations/History';
import Details from '../../views/reservations/Details';
import Reserve from '../../views/reservations/Reserve';

export default [
    {
        path: '/prenotazioni',
        name: 'reservations.history',
        component: History,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/prenotazioni/dettaglio/:id',
        name: 'reservations.details',
        component: Details,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/prenotazioni/prenota-tavolo',
        name: 'reservations.reserve',
        component: Reserve,
        meta: {showNav: true}
    }
]
